import { useState, useEffect, useRef } from 'react'
import styles from './InfoIcon.module.scss'
import { useWindowSize } from 'common/hooks/useWindowSize'
import cx from 'classnames'
import Button from 'common/components/Button/Button'
import { Translate } from 'react-localize-redux'

const infoIcon = ({ content, icon, tooltipClassName }) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState('right')
  const [tooltipPositionTop, setTooltipPositionTop] = useState('top')
  const { isMobile } = useWindowSize()
  const iconRef = useRef(null)
  useEffect(() => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect()
      setTooltipPosition(rect.left < window.innerWidth / 2 ? 'right' : 'left')
      setTooltipPositionTop(rect.top < 200 ? 'bottom' : 'top')
    }
  }, [showTooltip])

  const handleClick = () => {
    if (isMobile) {
      setShowModal(true)
    }
  }
  return (
    <>
      <div
        className={styles.infoIconWrapper}
        ref={iconRef}
        onMouseEnter={() => !isMobile && setShowTooltip(true)}
        onMouseLeave={() => !isMobile && setShowTooltip(false)}
        onClick={handleClick}
      >
        {icon}
        {showTooltip && !isMobile && (
          <div
            className={cx(
              styles.tooltip,
              tooltipClassName,
              styles[`tooltip--${tooltipPosition}`],
              styles[`tooltip--${tooltipPositionTop}`]
            )}
          >
            {content}
          </div>
        )}
      </div>

      {isMobile && showModal && (
        <div
          className={styles.modalBackdrop}
          onClick={() => setShowModal(false)}
        >
          <div
            className={cx(styles.modal, tooltipClassName)}
            onClick={e => e.stopPropagation()}
          >
            {content}
            <Button
              label={<Translate id='close' />}
              onClick={() => setShowModal(false)}
              type='cancel'
            />
          </div>
        </div>
      )}
    </>
  )
}

export default infoIcon
